import {z} from 'zod';

import {ApiError} from 'shared/web';

const DUPLICATE_TEMPLATE_TITLE_ERROR_CODE = 'DMS-CO-DO-0006';

const duplicateTemplateTitleErrorSchema = z.object({
  status: z.literal(400),
  data: z.object({
    errors: z.array(z.object({code: z.string()})),
  }),
});

export const isDuplicateTemplateTitleError = (error: ApiError) => {
  const result = duplicateTemplateTitleErrorSchema.safeParse(error);

  return (
    result.success &&
    result.data.data.errors.some(({code}) => code === DUPLICATE_TEMPLATE_TITLE_ERROR_CODE)
  );
};
